import { NotificationSettingsState } from "app/containers/Features/containers/TeamSettings/container/Notification/type";

export const initialState: NotificationSettingsState = {
  isLoading: false,
  settings: [],
};
